/**
 * Keeps the sticky-header spacer height correct after a viewport resize.
 *
 * The theme reserves space for the sticky header by measuring .header_section once and
 * writing the result as an inline height (jas_theme.js, stickyMenu):
 *
 *     header_section.css("height", "").css("height", header_section.outerHeight());
 *     $(window).resize(function() {
 *         // header_section.css("height", header_section.outerHeight());
 *     });
 *
 * The resize handler is there but its body is commented out, so the height is measured
 * once at load and never again. Load the page at any width and it is right; resize and it
 * keeps the old number. Measured on the Yellowfin PDP: 137px measured at 1280, still 137px
 * at 1100 where the natural height is 126 — an 11px band of dead space under the header.
 * The gap is much larger across the menu breakpoint, where the nav collapses to a burger.
 *
 * Note WHY the original line is commented out rather than just broken: it lacks the
 * `.css("height", "")` reset the load path does first. Without the reset it measures the
 * height it already pinned, so the header could grow but never shrink. Re-enabling that
 * line as written would have been worse than leaving it off. This resets first.
 *
 * Patched from our own asset because the storefront loads jas_theme.min.js — editing the
 * readable jas_theme.js would have no effect at all, and patching a minified vendor bundle
 * would not survive a theme update.
 */
(function () {
  var header = document.querySelector('.header_section');
  if (!header) return;

  // Match the theme's own guard: it only reserves space when the sticky header is on.
  var settings = window.nathan_settings || {};
  if (!settings.header_sticky) return;

  var inner = document.querySelector('.site_header');
  var STUCK = 'live_stuck';
  var pending = false;

  function isStuck() {
    return !!(inner && inner.classList.contains(STUCK));
  }

  function recalc() {
    // While stuck, .site_header is fixed and out of flow, so clearing the height would
    // measure the top bar alone and collapse the spacer. Defer to the next unstick.
    if (isStuck()) {
      pending = true;
      return;
    }
    pending = false;
    header.style.height = '';
    header.style.height = header.offsetHeight + 'px';
  }

  var timer = null;
  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(recalc, 150);
  }

  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);

  // Catch the deferred case: once the header unsticks, apply the resize we skipped.
  window.addEventListener(
    'scroll',
    function () {
      if (pending && !isStuck()) recalc();
    },
    { passive: true }
  );
})();
